import { useMemo, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { Iconmark } from 'src/shared/components/icons/logos/iconmark'
import { Button } from 'src/shared/components/ui/buttons/button'
import { useAuthState } from 'src/shared/features/auth/api/use-auth-state'
import Searchbar from 'src/shared/features/home/components/searchbar'
import SimpleSidebar from 'src/shared/features/home/components/simple-sidebar'
import { HamburgerIcon } from 'src/shared/features/home/icons/hamburger'
import useBreakpoint from 'src/shared/hooks/use-breakpoint'
import { useWindowSize } from 'src/shared/hooks/use-window-size'

import HeaderAuthIndicator from '../../marketplace/header-auth-indicator'

const PublicProfileHeader = () => {
  const { isSmTabletOrSmaller } = useBreakpoint()
  const { width } = useWindowSize()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const { isSignedIn, isConsumerSignedIn } = useAuthState()
  const navigate = useNavigate()

  const onPressIamProfessional = () => {
    window.open('https://www.joinconrad.ai', '_blank')
    // navigate(paths.auth.login.getHref(paths.users.profile.getHref(username || '')))
  }

  const onPressFindAgent = () => {
    navigate(paths.marketplace.instantMatch.profession.getHref('real_estate_agent'))
  }

  const onPressGetMortgage = () => {
    navigate(paths.marketplace.instantMatch.profession.getHref('mortgage_loan_officer', 'mortgage'))
  }

  const showAgentButtons = useMemo(() => {
    return width >= 1100
  }, [width])

  const showProfessionalButton = useMemo(() => {
    return !isSignedIn && !isConsumerSignedIn && !isSmTabletOrSmaller
  }, [isSignedIn, isConsumerSignedIn, isSmTabletOrSmaller])

  const showProfessionalSearchbar = useMemo(() => {
    return !isSmTabletOrSmaller
  }, [isSmTabletOrSmaller])

  const showHamburgerMenu = useMemo(() => {
    return isSmTabletOrSmaller
  }, [isSmTabletOrSmaller])

  return (
    <header className="z-50 flex h-[70px] w-full max-w-[1100px] items-center justify-between gap-5 bg-white px-5 transition-all duration-300 md:h-[102px] md:px-0">
      <div className="flex flex-1 flex-row items-center gap-[22px]">
        <Link to={paths.root.getHref()} className="flex h-full flex-col items-start justify-center gap-2">
          <Iconmark className="size-[29px]" />
        </Link>
        {showProfessionalSearchbar && (
          <Searchbar
            placeholder="Enter professional's name"
            className="h-[50px] max-w-[320px] flex-1 border-none bg-[#F8F7F5] sm:min-w-[280px]"
            iconClassName="text-muted"
            textClassName="text-primary bg-[#F8F7F5] placeholder:text-muted"
          />
        )}
      </div>
      <div className="flex flex-row items-center gap-4 xl:gap-7">
        {showAgentButtons && (
          <div className="flex flex-row items-center gap-4 xl:gap-7">
            <button className="shrink-0 p-2 text-[15px] font-semibold text-primary" onClick={onPressFindAgent}>
              Find an agent
            </button>
            <button className="shrink-0 p-2 text-[15px] font-semibold text-primary" onClick={onPressGetMortgage}>
              Get a mortgage
            </button>
          </div>
        )}
        <div className="flex flex-row items-center gap-[10px]">
          {showProfessionalButton && (
            <Button
              onClick={onPressIamProfessional}
              variant="outline"
              size="lg"
              className="h-[50px] shrink-0 rounded-full border-primary font-semibold"
            >
              {"I'm a professional"}
            </Button>
          )}
          <HeaderAuthIndicator variant="public-profile" />
          {showHamburgerMenu && (
            <>
              <button className="shrink-0 p-2 pl-[3px]" onClick={() => setSidebarOpen(true)}>
                <HamburgerIcon className="size-5 text-primary" />
              </button>
              <SimpleSidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
            </>
          )}
        </div>
      </div>
    </header>
  )
}

export default PublicProfileHeader
